import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { useState } from "react";

type Props = {
  title: string;
  description: string;
  onConfirm: () => void;
}

const useConfirmationDialog = () => {
  const [open, setOpen] = useState(false);
  const [props, setProps] = useState<Props | null>(null);

  return {
      confirmationDialog: (
        <Dialog open={open} onClose={() => setOpen(false)}>
          <DialogTitle>{props?.title}</DialogTitle>
          <DialogContent>
            <Typography>{props?.description}</Typography>
          </DialogContent>
          <DialogActions>
            <Button variant="outlined" color="error" onClick={() => setOpen(false)}>Annuler</Button>
            <Button variant="contained" onClick={props?.onConfirm}>Valider</Button>
          </DialogActions>
        </Dialog>
      ),
      confirm: ({title, description, onConfirm}: Props) => {
        setProps({title, description, onConfirm});
        setOpen(true);
      },
      closeConfirmationDialog: () => setOpen(false),
    };
};

export default useConfirmationDialog;